import React from "react"
import { Navigate, Route, Routes } from 'react-router-dom'

import SystemUsers from "../AdminConsole/SystemUsers/SystemUsers"
import Projects from "../AdminConsole/Projects/Projects"
import SystemLog from "../AdminConsole/SystemLog/SystemLog"

import NetworkRouterList from "../AdminConsole/DeviceManagement/NetworkRouter/NetworkRouterList"
import CameraList from "../AdminConsole/DeviceManagement/Camera/CameraList"

import AdminConsole from "./AdminConsole"
import SystemAdmins from "Pages/AdminConsole/SystemAdmins/SystemAdmins"

const AdminConsoleRouter = () => {
  return (
    <Routes>
      <Route path='/' element={<AdminConsole />}>
        <Route index element={<Navigate to="./system_admins" replace />} />
        
        <Route exact path="system_admins" element={<SystemAdmins />} />
        <Route exact path="system_users" element={<SystemUsers />} />
        <Route exact path="projects" element={<Projects />} />
        <Route exact path="system_log" element={<SystemLog />} />

        <Route exact path="network_router" element={<NetworkRouterList />} />
        <Route exact path="cameras" element={<CameraList />} />
      </Route>
    </Routes>
  )
}

export default AdminConsoleRouter
